import { PageComponentType } from '@laminar-product/client-commons-core/core';
import { JUMBOTRON_COMPONENTS_TYPES, WEB_CAROUSELS_TYPES } from './constants';

export const isJumbotronComponentType = (type?: PageComponentType) =>
  (type && JUMBOTRON_COMPONENTS_TYPES.includes(type)) || false;

export const isCarouselComponentType = (type?: PageComponentType) =>
  (type && WEB_CAROUSELS_TYPES.includes(type)) || false;
